import {
  ConversationStatus,
  MeetingBookingStatus,
  SearchableConversationFilterInput
} from 'generated-graphql/types';
import { acceptedStatuses, bookedMeetingStatuses } from './statuses';

// Mirrors getCampaignDisplayStatus so the filter and the stat match the chip.
const closedStatusFilter: SearchableConversationFilterInput = {
  or: [ConversationStatus.Completed, ...acceptedStatuses].map((status) => ({
    status: { eq: status }
  }))
};

export const schedulingSatisfiedFilter: SearchableConversationFilterInput = {
  and: [
    closedStatusFilter,
    {
      or: bookedMeetingStatuses.map((status) => ({
        meetingBookingStatus: { eq: status }
      }))
    }
  ]
};

export const schedulingIncompleteFilter: SearchableConversationFilterInput = {
  and: [
    closedStatusFilter,
    {
      or: [
        { meetingBookingStatus: { exists: false } },
        { meetingBookingStatus: { eq: MeetingBookingStatus.Cancelled } }
      ]
    }
  ]
};
